import {Box, TextField, Typography} from "@mui/material";

const CompanyCreateProductsTag = ({company, setField}) => {

  return (
      <Box sx={{display: "flex",
        flexDirection: "column",
        alignItems: "left",
        justifyContent: "center"}}>

        <Typography variant="h6" sx={{mb: 2, fontWeight: 600}}>Custom Fields</Typography>

        <TextField
            fullWidth
            multiline
            minRows={2}
            maxRows={4}
            sx={{mt: "16px"}}
            label="Custom Field 1"
            placeholder="Enter custom field 1 information"
            value={company.customField1 || ''}
            onChange={(event) => {
              setField("customField1", event.target.value);
            }}
        />

        <TextField
            fullWidth
            multiline
            minRows={2}
            maxRows={4}
            sx={{mt: "16px"}}
            label="Custom Field 2"
            placeholder="Enter custom field 2 information"
            value={company.customField2 || ''}
            onChange={(event) => {
              setField("customField2", event.target.value);
            }}
        />

        <TextField
            fullWidth
            multiline
            minRows={2}
            maxRows={4}
            sx={{mt: "16px"}}
            label="Custom Field 3"
            placeholder="Enter custom field 3 information"
            value={company.customField3 || ''}
            onChange={(event) => {
              setField("customField3", event.target.value);
            }}
        />

        <Typography variant="h6" sx={{mt: 4, mb: 2, fontWeight: 600}}>Product Offerings</Typography>

        <TextField
            fullWidth
            multiline
            minRows={3}
            maxRows={6}
            sx={{mt: "16px"}}
            label="Product Offering 1"
            placeholder="Describe your first product offering"
            value={company.productOffering1 || ''}
            onChange={(event) => {
              setField("productOffering1", event.target.value);
            }}
        />

        <TextField
            fullWidth
            multiline
            minRows={3}
            maxRows={6}
            sx={{mt: "16px"}}
            label="Product Offering 2"
            placeholder="Describe your second product offering"
            value={company.productOffering2 || ''}
            onChange={(event) => {
              setField("productOffering2", event.target.value);
            }}
        />

        <TextField
            fullWidth
            multiline
            minRows={3}
            maxRows={6}
            sx={{mt: "16px"}}
            label="Product Offering 3"
            placeholder="Describe your third product offering"
            value={company.productOffering3 || ''}
            onChange={(event) => {
              setField("productOffering3", event.target.value);
            }}
        />

      </Box>
  );
};

export default CompanyCreateProductsTag;
